<script>
export default {
    name: "additional-data-input",

    emits: ['input'],

    props: {
        value: {},
        additional: {}
    },

    computed: {
        modelValue: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit('input', value);
            },
        }
    }
}
</script>

<template>
    <div>
        <template v-for="(value, key) in modelValue">
            <b-row :key="key">
                <b-col cols="12">
                    <b-form-group
                        :id="key + '-label'"
                        class="row"
                        :label="key"
                        :label-for="key + '-input'"
                        label-cols="12"
                        content-cols="12"
                    >
                        <b-form-input :id="key + '-input'" v-model="modelValue[key]" :placeholder="value"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<style scoped>

</style>